<template>
	<div id="Main">
		<div class="imgbox">
			<van-image width="60%" fit="contain" :src="require('../../assets/images/service/cardtisp.png')" />
			<div class="title">
				<p class="p1">提示</p>
				<p class="p2">红利只能转入股东本人名下银行卡请确定是否修改默认卡信息</p>
			</div>
			<van-button type="info" round="" class="submit" @click="submit(1)">确定</van-button>
			<van-button type="info" round="" class="submit" @click="submit(2)">去修改默认银行卡信息</van-button>
		</div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				user:'',/* 账户号 */
				name:'',
				type:'',/* 银行卡状态 */
				auditStatusName:'',
				id:'',
				bank:'',
				card:'',
				
			}
		},
		methods: {
			submit(type) {
				if(type==1){
					if(this.type!=1){
						this.$toast({duration:4000,message:'此卡'+this.auditStatusName+'，暂时不能领取红利操作！'});
						return false
					}
					this.$router.push({
						path: '/applydividend',
						query:{
							user:this.user,
							name:this.name,
							bank:this.bank,
							card:this.card,
						}
					})
				}else{
					this.$router.push({
						path: '/addcard',
						query:{
							user:this.user,
							name:this.name,
							id:this.id,
						}
					})
				}
			},
		},
		mounted() {
			this.user = this.$route.query.user
			this.name = this.$route.query.name
			this.type = this.$route.query.type
			this.auditStatusName = this.$route.query.auditStatusName
			this.id = this.$route.query.id
			this.bank = this.$route.query.bank
			this.card = this.$route.query.card
			
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		background-color: #f2f9ff;
		min-height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		.submit {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin-top: 8rem;
			&:last-child{
				margin-top: 2rem;
				margin-bottom: 1rem;
				background-color: transparent;
				color: #fa6b6b;
				border: 1px solid #fa6b6b;
			}
		}


		.title {
			margin: 1.5rem auto;
			width: 60%;
			.p1 {
				font-weight: bold;
				color: #161616;
				font-size: 1.8rem;
				line-height: 2.5rem;
			}

			.p2 {
				color: #999999;
				font-size: 1.4rem;
				line-height: 2rem;
			}
		}

		.bor0 {
			border-bottom: 0;
		}

	}
</style>
